import { render, staticRenderFns } from "./MailValidationForm.vue?vue&type=template&id=64f54361&scoped=true&"
import script from "./MailValidationForm.vue?vue&type=script&lang=js&"
export * from "./MailValidationForm.vue?vue&type=script&lang=js&"
import style0 from "./MailValidationForm.vue?vue&type=style&index=0&id=64f54361&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f54361",
  null
  
)

export default component.exports